/**
 * Simple wrapper for wretch that takes care of things like cookies, content type, etc.
 *
 * @author Nick Dreckshage <ndreckshage@wayfair.com>
 * @copyright 2020 Wayfair LLC - All rights reserved
 */
/* eslint-env browser */
import TrackMount from './track-mount';
import TrackEvent from './track-event';
import TrackClick from './track-click';
import TrackVisible from './track-visible';
import TrackClickLocation from './track-click-location';
import TrackSiteImpression from './track-site-impression';
import TrackInView from './track-in-view';

export {
  // Tracker component helpers
  TrackMount,
  TrackEvent,
  TrackClick,
  TrackVisible,
  TrackClickLocation,
  TrackSiteImpression,
  TrackInView,
};
